import enviro from 'enviro';

// OTGs that are allowed to use Learn By Doing:
// https://docs.google.com/spreadsheets/d/17fkUMy4uMeOwnWqDNuIW1RKFZuP2uigOyBlOTeCvUP4/edit?gid=1614254752#gid=1614254752
export const ALLOWED_OTG_IDS = enviro.isProd() ? [1843222, 1846274, 1842560, 1843220, 2639657] : [33660538, 27527805, 39043943];
export const SOFTWARE_DISCOVERY_TOOL_RECOMMENDATIONS = 'software-discovery';